export const state = {
    transferenciaEstoque: {},
    transferenciasEstoques: [],
    modalCadastroTransferenciaEstoque: false,
    modalExcluirTransferenciaEstoque:false,
    modalVisualizarTransferenciaEstoque:false,
    itensTransferenciaEstoque: []
}

export default {}